import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';
import { format } from 'date-fns';

interface HeatmapCellProps {
  month: string;
  status: 'available' | 'missing' | 'no_data';
  billCount?: number;
  amount?: number;
  onClick: () => void;
}

export function HeatmapCell({ month, status, billCount, amount, onClick }: HeatmapCellProps) {
  const getCellStyles = () => {
    if (status === 'available') {
      return 'bg-[#b6f0c7] text-[#0b553f] hover:bg-[#9ee5b3]';
    }
    if (status === 'missing') {
      return 'bg-[#f7b6b6] text-[#6b0b0b] hover:bg-[#f5a0a0]';
    }
    return 'bg-[#eeeeee] text-[#666666] hover:bg-[#e0e0e0]';
  };

  const getStatusLabel = () => {
    if (status === 'available') return 'Available';
    if (status === 'missing') return 'Missing';
    return 'No Data';
  };

  const monthLabel = format(new Date(month), 'MMM yyyy');

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <button
            onClick={onClick}
            className={`min-w-[70px] h-10 flex items-center justify-center font-semibold text-sm border border-border rounded transition-all cursor-pointer focus:ring-2 focus:ring-ring focus:outline-none ${getCellStyles()}`}
            aria-label={`${monthLabel} - ${getStatusLabel()}`}
          >
            {status === 'available' && 'A'}
            {status === 'missing' && 'M'}
            {status === 'no_data' && ''}
          </button>
        </TooltipTrigger>
        <TooltipContent>
          <div className="text-sm">
            <p className="font-semibold">{monthLabel}</p>
            <p>Status: {getStatusLabel()}</p>
            {billCount && billCount > 0 && <p>Bills: {billCount}</p>}
            {amount && <p>Amount: ${amount.toFixed(2)}</p>}
          </div>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
